import { Route, Routes } from "react-router-dom";
import { privateRoutes, additionalPrivateRoutes, publicRoutes, universalRoutes, RouteConfig } from "./routeConfig";
import PublicRoute from "./PublicRoutes";
import PrivateRoute from "./PrivateRoutes";
import PrivateLayout from "../components/PrivateLayout";
import { useEffect } from "react";

const allPrivateRoutes = [...privateRoutes, ...additionalPrivateRoutes];

const renderRoutes = (routes: RouteConfig[]) =>
  routes.map(({ path, component: Component, subRoutes }) => {
    if (subRoutes && subRoutes.length > 0) {
      return (
        <Route key={path} path={path}>
          {renderRoutes(subRoutes)}
        </Route>
      );
    }
    if (Component) {
      return <Route key={path} path={path} element={<Component />} />;
    }
    return null;
  });

const Routing = () => {
  return (
    <Routes>
      {/* 🚨 GUESTS ONLY (Redirects to Dashboard if logged in) */}
      {publicRoutes.map(({ path, component: Component }) => (
        <Route
          key={path}
          path={path}
          element={<PublicRoute>{Component && <Component />}</PublicRoute>}
        />
      ))}

      {/* 🚨 UNIVERSAL ROUTES (Accessible to absolutely everyone) */}
      {universalRoutes.map(({ path, component: Component }) => (
        <Route
          key={path}
          path={path}
          element={Component && <Component />}
        />
      ))}
  
      {/* 🚨 PRIVATE ADMIN ROUTES */}
      <Route element={<PrivateRoute />}>
        <Route element={<PrivateLayout />}>
          {renderRoutes(allPrivateRoutes)}
        </Route>
      </Route>
    </Routes>
  );
}

export default Routing;